"use strict";
// The failure codes a call can end with, from the device, the broker and gd-client-api.
Object.defineProperty(exports, "__esModule", { value: true });
